"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMedicalRecordsPath = void 0;
function getMedicalRecordsPath(uid, assignationId = false) {
    if (!assignationId)
        return `user/${uid}/medical_records`;
    else
        return `user/${uid}/medical_records/${assignationId}`;
}
exports.getMedicalRecordsPath = getMedicalRecordsPath;
